<div class="px-5">
    <div class="col-sm-12 col-md-8">
        <section class="pb-4">
            <p class="small-heading text-color-black"> Suggested Loans Terms</p>
            <p class="header-detail">Here are the list of all suggested loans terms</p>
        </section>
    </div>

    <div *ngIf="loanSuggestedTerm" class="col-sm-12 col-md-4 text-end">
        <button (click)="getLoanSuggestedTerm()" mat-flat-button class="mat-primary mat-flat-button mt-md-5">Refresh
            data</button>
    </div>

    <div *ngIf="!loanSuggestedTerm">
        <mat-spinner [diameter]="35" class="mat-spinner center-block"></mat-spinner>
    </div>

    <ng-container *ngIf="loanSuggestedTerm">
        <mat-table #table [dataSource]="dataSource" matSort class="finzyfont">
            <ng-container matColumnDef="generatedLoanId">
                <mat-header-cell *matHeaderCellDef mat-sort-header>FINL</mat-header-cell>
                <mat-cell *matCellDef="let element" style="text-transform: uppercase;"> {{element.generatedLoanId
                    }}</mat-cell>
            </ng-container>


            <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
                <mat-cell *matCellDef="let element" style="text-transform: uppercase;"> {{element.name }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="loanAmount">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Loan Amount</mat-header-cell>
                <mat-cell *matCellDef="let element">{{element.loanAmount}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="indicatedLoanRate">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Indicated Loan Rate </mat-header-cell>
                <mat-cell *matCellDef="let element">{{element.indicatedLoanRate}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="indicatedLoanTenure">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Indicated Loan Tenure </mat-header-cell>
                <mat-cell *matCellDef="let element">{{element.indicatedLoanTenure}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="lenderSuggestedRate">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Suggested Interest Rate </mat-header-cell>
                <mat-cell *matCellDef="let element">{{element.lenderSuggestedRate}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="lenderSuggestedTenure">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Suggested Tenure </mat-header-cell>
                <mat-cell *matCellDef="let element">{{element.lenderSuggestedTenure}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="borrowerStatus" stickyEnd>
                <mat-header-cell *matHeaderCellDef mat-sort-header class="border-left">Action/Status</mat-header-cell>
                <mat-cell *matCellDef="let element" class="border-left"
                    [ngClass]="{'center-text': element.borrowerStatus !== '' && element.borrowerStatus !== null}">
                    <ng-container
                        *ngIf="element.borrowerStatus === '' || element.borrowerStatus === null || element.borrowerStatus === 'In Progress'">
                        <button mat-stroked-button color="primary" class="mx-1 custom-button custom-button-primary"
                            (click)="actionButtonHandler('Accepted', element)">Accept</button>
                        <button mat-stroked-button color="warn" class="mx-1 custom-button custom-button-danger"
                            (click)="actionButtonHandler('Rejected', element)">Reject</button>
                        <button mat-stroked-button color="accent" class="mx-1 modify custom-button-warning"
                            (click)="actionButtonHandler('Modified', element)">Modify</button>
                    </ng-container>
                    <ng-container *ngIf="element.borrowerStatus === 'Accepted'">
                        <div class="d-flex">
                            <mat-icon matSuffix class="text-success">check_circle</mat-icon>
                            <span class="font-bold">Accepted</span>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="element.borrowerStatus === 'Rejected'">
                        <div class="d-flex">
                            <mat-icon class="text-danger">cancel</mat-icon>
                            <span class="font-bold">Rejected</span>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="element.borrowerStatus === 'Modified'">
                        <div class="d-flex">
                            <mat-icon class="text-warning">sync</mat-icon>
                            <span class="font-bold">Negotiation in progress</span>
                        </div>
                    </ng-container>
                </mat-cell>

            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
        <mat-paginator [pageSizeOptions]="[5,10, 25, 100]" aria-label="Select page of users"></mat-paginator>

    </ng-container>
</div>